import React from 'react'
import url from 'libraries/front-end-core/core/url'
import Grid from '@mui/material/Grid'
import { CURRENT_AWARENESS } from 'constants/controllers'
import { flatMappedStories } from 'pages/currentawareness/Util'
import { Story } from 'pages/dashboard/CaStories'
import { CaThemeProvider } from 'components/redesign/CaThemeProvider'
import ArrowLink from 'components/redesign/ArrowLink'
import Box from '@mui/material/Box'
import ResponseConsumer from 'components/shared/ResponseConsumer'

const RecentStoriesTitle = ({ aol }) => {
  return (
    <>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <div className='black ph8 mt7 mb6 flex items-center justify-between'>
          <span className='f3 b'>Recent News</span>
          <ArrowLink text='View all news' url={url(CURRENT_AWARENESS, { aol })} />
        </div>
      </Box>
      <div className='relative'>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <div style={{ height: '4.5rem' }} className='absolute -top10 w-100 h5'>
            <div className='relative black pl6 h-100 w-100'>
              <div className='absolute bottom6 w-100'>
                <Grid container justifyContent='space-between' className='flex-wrap-reverse'>
                  <Grid item className='f3 b mr6'>Recent News</Grid>
                  <Grid item className='pr6'>
                    <ArrowLink text='View all News' url={url(CURRENT_AWARENESS, { aol })} textCx='mt4' />
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </Box>
      </div>
    </>
  )
}

const RecentStories = ({ homepageArticles, filterId, aol, isLogged }) => {
  const filteredStories = flatMappedStories(homepageArticles)
    .filter(story => story.id !== filterId)
    .sort((uno, dos) => uno.position - dos.position)
    .slice(0, 6)

  return (
    <CaThemeProvider>
      <RecentStoriesTitle aol={aol} />
      <div className='bt-thick bt--dark-cerulean mb6' />
      <Grid container direction='column'>
        <Grid container direction='row' spacing={2} className='mt0 pb4 ghost-grey h-100'>
          {filteredStories.map(story => (
            <Grid item xs={12} sm={6} md={12} key={story.id}>
              <Story {...story} aol={aol} isLogged={isLogged} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </CaThemeProvider>
  )
}

const RecentStoriesWrapper = ({ homepageArticles, filterId, aol, isLogged }) => (
  <ResponseConsumer
    response={homepageArticles}
    content={() => <RecentStories {...{ homepageArticles, filterId, aol, isLogged }} />}
  />
)

export default RecentStoriesWrapper
